import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import styles from "./Header.module.scss";

import { getReportHeader } from "../../../../../api/milestonesSummary/milestonesSummary";
import { useUserData } from "../../../../../hooks/useUserProfile";
import { HeaderMilestones } from "../../../../../types/milestonesSummary";
import { formatDate } from "../../../../../utils/formatDate";
import { Loader } from "../../../../Loader";
import { HeaderLogo } from "../../../HederLogo";
import { HeaderFilters } from "../HeaderFilters";

export const Header = () => {
  const { syncLogId } = useParams();

  const { organizationId, tenantId } = useUserData();
  const { reportId } = useParams();

  const { data: headerInfo, isLoading } = useQuery({
    queryKey: ["getHeaderMilestones", tenantId, reportId, syncLogId],
    queryFn: async (): Promise<HeaderMilestones | undefined> => {

          const headerInfo = await getReportHeader(
            syncLogId!,
            organizationId,
            tenantId,
          );

          return(headerInfo.data.data);
      },
    enabled: !!tenantId && !!reportId && !!syncLogId,
  });

  return (
    <div className={styles.root}>
      <HeaderLogo title={headerInfo?.reportName} />

      {isLoading && <Loader />}
      {!isLoading && headerInfo && (
        <HeaderFilters
          completed={headerInfo?.completedStates}
          projects={headerInfo?.projects}
          milestoneType={headerInfo?.milestoneTypes}
          maxPeriod={formatDate(headerInfo.maxPeriod)}
          minPeriod={formatDate(headerInfo.minPeriod)}
        />
      )}
    </div>
  );
};
